import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.trading_data.unlink_account_modal.title',
        defaultMessage:
            'Are you sure you’d like to unlink your { bankName } account?'
    },
    subTitle: {
        id: '_.trading_data.unlink_account_modal.sub_title',
        defaultMessage:
            'Unlinking a bank will remove all of the accounts that you hold with that bank from your iwoca account.'
    },
    unlink: {
        id: '_.trading_data.unlink_account_modal.unlink',
        defaultMessage: 'Unlink'
    },
    cancel: {
        id: '_.trading_data.unlink_account_modal.cancel',
        defaultMessage: 'Cancel'
    }
});
